import React from 'react';
import { motion } from 'framer-motion';
import ExperienceCard from './RigCard';
import { useBookingConfig } from '@/lib/BookingConfigContext';

export default function BookingStepRigSelection({ experienceType, onSelect }) {
  const { experiences } = useBookingConfig();

  const list = Object.entries(experiences)
    .map(([key, exp]) => ({ key, ...exp }))
    .filter((e) => e.active !== false)
    .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0));

  return (
    <motion.div key="s1" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -20 }}>
      <p className="text-white/40 text-sm mb-6">
        Choose an experience below. Each session includes up to 50 minutes of drive time, plus 10 minutes for a professional safety briefing and debrief. Looking to book a longer session? Contact us at{' '}
        <a href="mailto:sales@motionreality.co.uk" className="text-primary hover:underline">sales@motionreality.co.uk</a>.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-stretch">
        {list.map(({ key }, i) => (
          <ExperienceCard key={key} type={key} selected={experienceType === key} onSelect={onSelect} index={i} />
        ))}
      </div>
    </motion.div>
  );
}